import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { Course } from '../../courses/shared/course';
import { CourseLectureService } from '../../courses/shared/course-lecture.service';
import { DialogButtonBase } from '../../shared/base/dialog-button-base';
import { QuestionBase } from '../../shared/dynamic-form/shared/question-base';
import { SelectQuestion } from '../../shared/dynamic-form/shared/question-select';
import { SelectOption } from '../../shared/dynamic-form/shared/question-select-option';
import { MESSAGE_COMMON_ERROR } from '../../shared/message';
import { Lecture } from '../shared/lecture';
import { MESSAGE_ADD_LECTURE_SUCCESS } from '../shared/lecture-message';
import { LectureService } from '../shared/lecture.service';

@Component({
  selector: 'app-lecture-import-button',
  template: '<ng-content></ng-content>'
})
export class LectureImportButtonComponent extends DialogButtonBase implements OnInit, OnDestroy {
  @Input() course: Course;
  private lecturesObservable: Observable<Lecture[]>;
  private _lecturesSubscription: Subscription;
  private options: SelectOption[];

  constructor(dialog: MatDialog, snackBar: MatSnackBar, private service: LectureService, private refService: CourseLectureService) {
    super(dialog, snackBar);
  }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  ngOnInit() {
    this.lectures = this.service.list;
    // if (this.course.billing) {
    //   this.lectures = this.service.list;
    // } else {
    //   this.service.filterBilling('false');
    //   this.lectures = this.service.visibleLectures$;
    // }
  }

  ngOnDestroy() {
    this.lecturesSubscription = null;
  }

  openDialog(): void {
    super.openDialog(this.title, this.questions);
  }

  async onSubmit({ lecture }): Promise<any> {
    try {
      await this.refService.addRef(this.course.$key, lecture);
      this.closeDialog();
      this.openSnackBar(MESSAGE_ADD_LECTURE_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  set lectures(value: Observable<Lecture[]>) {
    this.lecturesObservable = value;
    this.lecturesSubscription = this.lecturesObservable.subscribe(this.updateOptions.bind(this));
  }

  private set lecturesSubscription(value: Subscription) {
    if (this._lecturesSubscription && !this._lecturesSubscription.closed) {
      this._lecturesSubscription.unsubscribe();
    }
    this._lecturesSubscription = value;
  }

  private updateOptions(lectures: Lecture[]) {
    this.options = lectures.map(lecture => ({
      label: lecture.name,
      value: lecture.$key
    }));
  }

  private get title(): string {
    return '강의 가져오기';
  }

  private get questions(): Array<QuestionBase<any>> {
    return [
      new SelectQuestion({
        key: 'lecture',
        label: '강의 선택',
        required: true,
      }, this.options)
    ];
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-import-button/lecture-import-button.component.ts